import { createContext } from "react";
import { QueryObserverResult } from "react-query";
import { Post, PostElement } from "src/api/client-api/post/postSchema";
import { Ssq } from "src/api/sure-api/ssq/useGetOneSsq";
import { SsqVersion, SsqVersionSsq } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";
import type { ComponentAppearance } from "src/components/appearance";

export type ElementsMapping = Partial<Record<number, PostElement[]>>;

export type QuestionnaireContextCommonValues = {
    title: string | ((ssq: Ssq | SsqVersionSsq | undefined) => string);
    subtitle?: string | ((ssq: Ssq | SsqVersionSsq | undefined) => string);
    getHeadingUrl: (headingId: number) => string;
    backUrl: string;
    canEdit: boolean;
    appearance?: ComponentAppearance;
    ingredientReferenceId?: number;
};

type QuestionnaireContextValues = {
    ssqVersion: SsqVersion | undefined;
    isSsqVersionLoading: boolean;
    post: Post | undefined;
    isPostLoading: boolean;
    isPostError: boolean;
    elementsByPropertyId: ElementsMapping;
    ingredientGenericValues: Partial<Record<number, string>>;
    refetchPost: () => Promise<QueryObserverResult<Post | undefined>>;
    openUnitConverterKey: string | null;
    setOpenUnitConverterKey: (key: string | null) => void;
} & QuestionnaireContextCommonValues;

export const QuestionnaireForm = createContext<QuestionnaireContextValues | null>(null);
